import { dataLayerConfig } from '@aspendental/shared-components-web';

import { useScheduleQuestionsStore } from '@src/store';

export const handlePageLeave = (event) => {
	const anchor = event.target.closest('a'); // Check for closest <a> tag

	if (
		anchor &&
		Object.keys(useScheduleQuestionsStore.getState().questionsAnswers).length > 0 &&
		!anchor.href.startsWith('#') &&
		!anchor.href.endsWith('#') &&
		!anchor.href.startsWith('tel:') &&
		!anchor.href.startsWith('mailto:') &&
		anchor.target !== '_blank'
	) {
		event.stopPropagation();
		event.preventDefault();
		dataLayerConfig({ event: 'scheduleform_abandomentwarning' });

		const shouldLeave = confirm(
			'Are you sure you want to leave? If you leave this page, your progress will not be saved.'
		);

		if (shouldLeave) {
			// Remove listener temporarily to avoid duplicate calls
			document.removeEventListener('click', handlePageLeave, true);
			window.location.href = anchor.href;
		} else {
			event.stopPropagation();
			event.preventDefault();
		}
	}
};
